export default "__VITE_ASSET__BIhwqP6U__"